export default "__VITE_ASSET__EhtjkvHf__"